/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

export class BinaryWriter {
    private buffer: number[] = [];
  
    writeu8(value: number) {
      this.buffer.push(value & 0xff);
    }
  
    writeu16(value: number) {
      this.buffer.push(value & 0xff, (value >> 8) & 0xff);
    }
  
    writeu32(value: number) {
      this.buffer.push(
        value & 0xff,
        (value >> 8) & 0xff,
        (value >> 16) & 0xff,
        (value >> 24) & 0xff
      );
    }
  
    writeu64(value: number | bigint) {
      const val = BigInt(value);
      for (let i = 0; i < 8; i++) {
        this.buffer.push(Number((val >> BigInt(i * 8)) & BigInt(0xff)));
      }
    }
  
    writeString(str: string) {
      const bytes = new TextEncoder().encode(str);
      this.writeu32(bytes.length); // Rust formatting: Length (u32) then bytes
      bytes.forEach((b) => this.buffer.push(b));
    }
  
    writePubkey(pubkeyStr: string) {
        // We assume input is Base58 string, but for raw instruction data usually passed as byte array
        // If we don't have a base58 decoder handy in this context without imports:
        // We will assume the caller passes the byte array directly or we skip strict validation here
        // For this specific helper, we will rely on standard web3.js functionality in the main file
        // This method is a placeholder if we needed raw byte pushing.
    }

    writeBytes(bytes: number[] | Uint8Array) {
        bytes.forEach(b => this.buffer.push(b));
    }
  
    toBuffer(): Uint8Array {
      return new Uint8Array(this.buffer);
    }
  }